import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, NavigationEnd } from '@angular/router';
import { DepartmentSelectorComponent } from '../department-selector/department-selector.component';
import { ToolbarService } from './toolbar.service';
import { PhAuthService } from '@frontend/common/ph-auth';
import { map, Observable, filter, startWith, combineLatest, of, merge } from 'rxjs';
import { Document360Service } from '@frontend/common/src/lib/util';

@Component({
  selector: 'wrt-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  providers: [ToolbarService],
  standalone: false
})
export class ToolbarComponent {
  public accessDepartmentsConfiguration$: Observable<boolean>;
  public showDepartmentSelector$: Observable<boolean>;
  public departmentWithVisibility$: Observable<{department: any, show: boolean}>;
  constructor(
    private dialog: MatDialog, 
    private srv: ToolbarService,
    private phAuthSrv: PhAuthService,
    private router: Router,
    private readonly doc360Service: Document360Service,
  ) {
    this.accessDepartmentsConfiguration$ = this.phAuthSrv.scopes$.pipe(
      map((scopes: any[]) => scopes.includes('ui:ca:wrt-departments'))
    );
    this.showDepartmentSelector$ = merge(
      of(this.router.url),
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.router.url)
      )
    ).pipe(
      map(url => !url.startsWith('/configuration') && !url.includes('/map'))
    );
    this.departmentWithVisibility$ = combineLatest(
      this.srv.department$.pipe(startWith(null)),
      this.showDepartmentSelector$
    ).pipe(
      map(([department, show]) => ({ department, show }))
    );
  }

  get department$() {
    return this.srv.department$;
  }

  get user$() {
    return this.srv.user$;
  }

  openDoc360Widget(): void {
    this.doc360Service.openDoc360Widget();
  }

  openChangeDepartmentDialog() {
    this.dialog.open(DepartmentSelectorComponent, {
      closeOnNavigation: true,
      width: '500px',
      panelClass: ['no-padding'],
    });
  }
}
